<template>
    <svg
        id="Warning"
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 18 18"
    >
        <circle
            id="Ellipse_90"
            data-name="Ellipse 90"
            cx="9"
            cy="9"
            r="9"
            fill="#e1c7ab"
        />
        <g id="CheckOnly" transform="translate(4.649 5.685)">
            <path
                id="Pfad_305"
                data-name="Pfad 305"
                d="M144.715,47.547a.549.549,0,0,1-.386-.161l-2.651-2.629a.59.59,0,0,1-.016-.815.547.547,0,0,1,.789-.016l2.242,2.224,4.549-5.051a.545.545,0,0,1,.787-.029.589.589,0,0,1,.028.814l-4.934,5.478a.548.548,0,0,1-.393.183Z"
                transform="translate(-141.506 -40.917)"
                fill="#fff"
            />
        </g>
    </svg>
</template>
<script>
import { defineComponent } from "vue";

export default defineComponent({
    name: "SuccessIcon",
    props: {},
});
</script>
